// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/assets/images/icons/v2/24/24-close.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ticket-dialog {
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  animation: keyframes-grow-in 300ms cubic-bezier(0, 0, 0.38, 0.9) 0ms;
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  background-color: #FFFFFF;
  z-index: 10;
}
ticket-dialog > header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px 24px 16px 24px;
}
ticket-dialog > header div.label {
  font-family: "Incinet Bold", sans-serif;
  font-size: 21px;
  font-style: normal;
  line-height: normal;
  color: #181818;
  text-transform: uppercase;
}
ticket-dialog > header div.icon {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  background-color: #181818;
}
ticket-dialog > header div.icon-close {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
ticket-dialog > article {
  flex-grow: 1;
  overflow: auto;
  padding: 0 24px;
}
ticket-dialog > article div.empty {
  font-family: "Incinet Regular", sans-serif;
  font-size: 18px;
  font-style: normal;
  line-height: normal;
  color: #FFFFFF;
  padding: 32px 16px;
  text-align: center;
  margin-bottom: 16px;
}
ticket-dialog > article div.ticket {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 210px;
  box-sizing: border-box;
  border-radius: 6px;
  margin-bottom: 16px;
  overflow: hidden;
}
ticket-dialog > article div.ticket-invalid {
  background-color: #FF1267;
  overflow: auto;
}
ticket-dialog > article div.ticket div.invalid {
  font-family: "Incinet Semi Bold", sans-serif;
  font-size: 23px;
  font-style: normal;
  line-height: normal;
  font-size: 44px;
  color: #FFFFFF;
  padding: 24px;
  line-height: 100%;
}
ticket-dialog > article div.ticket div.time {
  background-color: #12FF67;
  padding: 24px;
}
ticket-dialog > article div.ticket div.zone {
  background-color: #E9E9E9;
  padding: 24px;
}
ticket-dialog > article div.ticket div.valid {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
}
ticket-dialog > article div.ticket div.valid div.column {
  font-family: "Incinet Semi Bold", sans-serif;
  font-size: 23px;
  font-style: normal;
  line-height: normal;
  font-size: 44px;
  color: #181818;
  margin-bottom: 4px;
  text-align: center;
}
ticket-dialog > article div.ticket div.valid div.column div.date {
  font-family: "Incinet Regular", sans-serif;
  font-size: 16px;
  font-style: normal;
  line-height: normal;
}
ticket-dialog > article div.ticket div.valid div.column-left {
  width: 40%;
}
ticket-dialog > article div.ticket div.valid div.column-right {
  width: 40%;
}
ticket-dialog > article div.ticket div.valid div.column-center {
  text-align: center;
}
ticket-dialog > article div.ticket div.area {
  font-family: "Incinet Regular", sans-serif;
  font-size: 16px;
  font-style: normal;
  line-height: normal;
  color: #181818;
  margin-bottom: 4px;
}
ticket-dialog > article div.ticket div.terminal {
  font-family: "Incinet Regular", sans-serif;
  font-size: 16px;
  font-style: normal;
  line-height: normal;
  color: #181818;
}
ticket-dialog > footer {
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 4px;
  padding: 24px;
}`, "",{"version":3,"sources":["webpack://./src/aptl/components/ticket-dialog/ticket-dialog.scss","webpack://./src/aptl/components/styles/_mixins.scss","webpack://./src/aptl/components/styles/_colors.scss","webpack://./src/aptl/components/styles/_styles.scss"],"names":[],"mappings":"AAIA;ECoCE,aAAA;EACA,sBAAA;EAmDA,0CAAA;EAJA,oEAAA;EDhFA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yBEZS;EFaT,WAAA;AAFF;AAIE;ECkBA,aAAA;EACA,mBAAA;EDjBE,8BAAA;EACA,uBAAA;EACA,4BAAA;AADJ;AAGI;ECdF,uCAAA;EE+FA,eAAA;EACA,kBAAA;EACA,mBAAA;EHjFI,cEtBI;EFuBJ,yBAAA;AAEN;AACI;ECDF,WDEsC;ECDtC,YDC4C;ECA5C,eAAA;EACA,gBDD4C;EACxC,yBE5BI;AFgCV;AAFM;EACE,mDAAA;AAIR;AACE;ECUA,YAAA;EDRE,cAAA;EACA,eAAA;AACJ;AAEI;EC5CF,0CAAA;EEyBA,eAAA;EACA,kBAAA;EACA,mBAAA;EHmBI,cE7CK;EF8CL,kBAAA;EACA,kBAAA;EACA,mBAAA;AAGN;AAAI;ECbF,aAAA;EACA,sBAAA;EDcI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAGN;AADM;EACE,yBExDK;EFyDL,cAAA;AAGR;AAAM;EC9DJ,4CAAA;EEsEA,eAAA;EACA,kBAAA;EACA,mBAAA;EHRM,eAAA;EACA,cEpEG;EFqEH,aAAA;EACA,iBAAA;AAKR;AAFM;EACE,yBEpEK;EFqEL,aAAA;AAIR;AADM;EACE,yBE7EE;EF8EF,aAAA;AAGR;AAAM;ECpCJ,YAAA;EAdA,aAAA;EACA,mBAAA;ADsDF;AADQ;ECpFN,4CAAA;EEsEA,eAAA;EACA,kBAAA;EACA,mBAAA;EHcQ,eAAA;EAEA,cE1FA;EF2FA,kBAAA;EACA,kBAAA;AAKV;AAHU;EChGR,0CAAA;EEWA,eAAA;EACA,kBAAA;EACA,mBAAA;AH4FF;AALU;EACI,UAAA;AAOd;AAJU;EACE,UAAA;AAMZ;AAHU;EACE,kBAAA;AAKZ;AAAM;EClHJ,0CAAA;EEWA,eAAA;EACA,kBAAA;EACA,mBAAA;EHuGM,cElHE;EFmHF,kBAAA;AAKR;AAFM;ECxHJ,0CAAA;EEWA,eAAA;EACA,kBAAA;EACA,mBAAA;EH6GM,cExHE;AF+HV;AAFE;EC7FA,aAAA;EACA,mBAAA;ED8FE,oBAAA;EACA,QAAA;EACA,aAAA;AAKJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
